<template>
  <CompanyDialog
    :dialogTitle="dialogTitle"
    :centerDialogVisible="visible"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'1000px'"
    :key="dialogKey"
  >
    <el-form :model="query" :inline="true" label-width="120px">
      <el-form-item label="公司名称" prop="companyName">
        <el-input
          v-model="query.companyName"
          class="el-input-width"
          placeholder="公司名称"
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="handleSearch">查询</el-button>
    </el-form>

    <div>
      <table-list
        :table-data="tableData"
        :table-label="tableLabel"
        :loading="loading"
        class="table"
      >
        <template v-slot:id="slot">
          <el-radio
            :label="slot.scope.$index"
            v-model="companyRadio"
            @change.native="handleGetCurrentRow(slot.scope.row)"
          ></el-radio>
        </template>
      </table-list>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.currentPage"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div>
    </div>
  </CompanyDialog>
</template>

<script>
import CompanyDialog from '../../../../../components/common/epecDialog';
import TableList from '../../common/e-table-list';
import Api from '../../../api/agreement/index';
export default {
  name: 'companyDialog',
  components: {
    TableList,
    CompanyDialog
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    dialogKey: {
      type: Number,
      required: true
    },
    dataDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      tableLabel: [
        {
          label: '',
          align: 'center',
          type: 'index',
          slot: 'id',
          width: '30',
          fixed: 'left'
        },
        { label: '公司名称', param: 'companyName', align: 'center' },
        { label: '公司编号', param: 'companyId', align: 'center', width: '200' }
      ],
      loading: false,
      query: {
        companyName: ''
      },
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      dialogTitle: '选择公司',
      companyRadio: ''
    };
  },
  computed: {},
  created() {
    // this.getCompanyList()
  },
  methods: {
    handleSearch() {
      this.productTagPage.currentPage = 1;
      this.getCompanyList();
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.getCompanyList();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.getCompanyList();
    },
    updateVisible() {},
    resetPopupData() {
      this.$emit('close');
    },
    submitPopupData() {
      this.$emit('close');
    },
    handleGetCurrentRow(val) {
      this.$emit('getCompanyInfo', val);
    },
    getCompanyList() {
      let params = {
        companyName: this.query.companyName,
        pageNum: this.productTagPage.currentPage,
        pageSize: this.productTagPage.pageSize
      };
      if (this.dialogKey == 1) {
        Api.queryFirstPartyList(params).then(res => {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
        });
      } else {
        Api.querySupplierList(params).then(res => {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table ::v-deep .el-radio__label {
  color: #ffffff;
}
</style>
